import { v4 as uuidv4 } from "uuid";
import { sentLogEvent } from "../../../../httpRequests/elasticSearch";

export default (jvId) => async (_, getState) => {
  const { auth } = getState();
  let userId = "";
  if (auth.loggedIn && auth.userProfile && auth.userProfile.profile && auth.userProfile.profile.id) {
    userId = auth.userProfile.profile.id.toString();
  }

  try {
   
    let params = {
      event: "recentviews",
      type: "recentviews",
      jvId: jvId,
      userId: userId
    }
    if (auth.loggedIn && Boolean(userId)) {
      sentLogEvent({ params }).then(() => null);
    }
    
    params = {
      event: "videoviews",
      type: "videoviews",
      jvId: jvId,
      userId: auth.loggedIn ? userId : uuidv4(),
      isGuest: !auth.loggedIn
    }
    sentLogEvent({ params }).then(() => null);

  } catch (error) {
    console.log(error)
  }  
}